// extracted by mini-css-extract-plugin
export var addToCartStyle = "product-page-module--addToCartStyle--r5Cxs";
export var breadcrumb = "product-page-module--breadcrumb--TUr7s";
export var container = "product-page-module--container--EREiA";
export var header = "product-page-module--header--ZAnqx";
export var labelFont = "product-page-module--labelFont--nMPhI";
export var metaSection = "product-page-module--metaSection--lSCM7";
export var noImagePreview = "product-page-module--noImagePreview--uzW3V";
export var optionsWrapper = "product-page-module--optionsWrapper--jH9zF";
export var priceValue = "product-page-module--priceValue--gk0OJ";
export var productBox = "product-page-module--productBox--futuv";
export var productDescription = "product-page-module--productDescription--GKu-y";
export var productImageList = "product-page-module--productImageList--6cRAn";
export var productImageListItem = "product-page-module--productImageListItem--P3+RE";
export var productImageWrapper = "product-page-module--productImageWrapper--++InC";
export var scrollForMore = "product-page-module--scrollForMore--Wcc95";
export var selectVariant = "product-page-module--selectVariant--m-gJw";
export var tagList = "product-page-module--tagList--I5sOk";
export var visuallyHidden = "product-page-module--visuallyHidden--Px8+B";